import moment from "moment";

const RescheduleAttendanceWarning = ({ rescheduleAttendances }) => {
  return (
    <div className="mb-4">
      <h6 className="text-center mb-3 text-danger">
        振替予定がある生徒 ({rescheduleAttendances.length}名)
      </h6>
      <div className="alert alert-danger mb-3 p-1 w-100" role="alert">
        <div className="d-flex flex-column gap-2">
          {rescheduleAttendances.map(attendance => (
            <div key={attendance.id} className="d-flex gap-2">
              <strong>
                会員番号{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`/admin/student/details/${attendance.member_classes.member.id}?action=update&key=tab4`}
                >
                  {attendance.member_classes.member.member_code}
                </a>
                :
              </strong>
              <span>
                {moment(attendance.attendance_date).format(
                  "YYYY年MM月DD日(ddd)"
                )}
              </span>
              <span>{attendance.regular_class_schedule.option_string}</span>
            </div>
          ))}
        </div>
        <div className="d-flex flex-column gap-3">
          <div style={{ fontSize: "14px" }}>
            ※この操作を続行する前に、上記の振替予定の処理を完了する必要があります。
          </div>
        </div>
      </div>
    </div>
  );
};

export default RescheduleAttendanceWarning;
